// removed by extract-text-webpack-plugin
module.exports = {"overlay":"overlay__SOtrt","active":"active__112Fi"};


//////////////////
// WEBPACK FOOTER
// ../~/react-toolbox/lib/overlay/theme.css
// module id = Nstp
// module chunks = 6